import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

// Import pages converted from Next.js
import HomePage from './pages/HomePage';
import Dashboard from './pages/Dashboard';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import ProjectTasksPage from './pages/ProjectTasksPage';
import TaskQuotesPage from './pages/TaskQuotesPage';
import QuoteComparisonPage from './pages/QuoteComparisonPage';
import NewProjectPage from './pages/NewProjectPage';
import CustomersPage from './pages/CustomersPage';
import SuppliersPage from './pages/SuppliersPage';
import CalendarPage from './pages/CalendarPage';
import NotificationsPage from './pages/NotificationsPage';
import CustomerProjectPage from './pages/CustomerProjectPage';
import CustomerTimelinePage from './pages/CustomerTimelinePage';
import SupplierQuotePortal from './pages/SupplierQuotePortal';
import SupplierPortalLogin from './pages/SupplierPortalLogin';
import JobSheetAcknowledgmentPage from './pages/JobSheetAcknowledgmentPage';
import QueryManagementPage from './pages/QueryManagementPage';
import AdminPage from './pages/AdminPage';
import SettingsPage from './pages/SettingsPage';
import AIDashboard from './pages/AIDashboard';
import AuthCompletePage from './pages/AuthCompletePage';
import SupplierDashboard from './pages/SupplierDashboard';
import { EmailLinkSignIn } from './components/auth/EmailLinkSignIn';
import CommunicationsPage from './pages/CommunicationsPage';
import SupplierInboxPage from './pages/SupplierInboxPage';
import CustomerInboxPage from './pages/CustomerInboxPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<HomePage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            
            {/* Projects */}
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/new" element={<NewProjectPage />} />
            <Route path="/projects/:id" element={<ProjectDetailPage />} />
            <Route path="/projects/:id/tasks" element={<ProjectTasksPage />} />
            <Route path="/projects/:id/tasks/:taskId/quotes" element={<TaskQuotesPage />} />
            <Route path="/projects/:id/tasks/:taskId/quotes/compare" element={<QuoteComparisonPage />} />
            
            {/* Other Pages */}
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/suppliers" element={<SuppliersPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/communications" element={<CommunicationsPage />} />
            <Route path="/queries" element={<QueryManagementPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            
            {/* Customer Portal */}
            <Route path="/customer/project/:id" element={<CustomerProjectPage />} />
            <Route path="/customer/timeline/:id" element={<CustomerTimelinePage />} />
            <Route path="/customer/inbox/:id" element={<CustomerInboxPage />} />
            <Route path="/customer-inbox" element={<CustomerInboxPage />} />
            
            {/* AI Dashboard */}
            <Route path="/ai-dashboard" element={<AIDashboard />} />
            
            {/* Authentication */}
            <Route path="/auth/signin" element={<EmailLinkSignIn />} />
            <Route path="/auth/complete" element={<AuthCompletePage />} />
            
            {/* Supplier Portal */}
            <Route path="/quote/:token" element={<SupplierQuotePortal />} />
            <Route path="/supplier-login" element={<SupplierPortalLogin />} />
            <Route path="/supplier-dashboard/:token" element={<SupplierDashboard />} />
            <Route path="/supplier-inbox" element={<SupplierInboxPage />} />
            <Route path="/job-sheet/:jobSheetId" element={<JobSheetAcknowledgmentPage />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;